import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {AUDIENCE_RECALCULATION_STATUS_QUERY_KEY} from "../queryKeys";
import {AudienceRecalculationStatus} from "./types";

type Data = AudienceRecalculationStatus;

const getAudienceRecalculationStatus = async (): Promise<Data> => {
  const response = await axiosReachInstance.get<Data, AxiosResponse<Data>>("/audiences/recalculation-status");
  return response.data;
};

export const useGetAudienceRecalculationStatus = (options?: BaseQueryOptions<Data, void>): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, void>(
    [AUDIENCE_RECALCULATION_STATUS_QUERY_KEY],
    getAudienceRecalculationStatus,
    undefined,
    options
  );
};
